module.exports = __webpack_public_path__ + "static/media/sandwich.f84af199.jpg";